import { UtilityService } from '@shared/services/utility.service';
import { Injectable } from '@angular/core';
import { camel } from 'radash';

@Injectable({
  providedIn: 'root',
})
export class ApiTranslatorService {
  constructor(private _utilityService: UtilityService) {}

  /**
   * Transalte given @ActiveModel class instance using javascript camelCase syntax and return new snake_case object ready for Rails backend
   * @param model model in camelCase to translate => snake_case
   */
  /*modelToSnakeCase(model): any {
    const apiModel = {};
    if (model) {
      for (const key of Object.keys(model)) {
        if (!!model[key] && typeof model[key] === 'object' && !(model[key] instanceof Date)) {
          console.log('convirtiendo 1', model[key]);
          apiModel[ snakeCase(key) ] = this.modelToSnakeCase(model[key]);

        } else if (!!model[key] && model[key] instanceof Array) {
          console.log('analizando array...', model[key]);
          apiModel[snakeCase(key)] = model[key].map(value => this.modelToSnakeCase(value));
        } else {
          console.log('convirtiendo else ...', model[key]);
          apiModel[ snakeCase(key) ] = model [key];
        }
      }
    }
    return apiModel;
  }*/

  modelToSnakeCase(model: any): any {
    const apiModel: any = {};
    const camelToSnake = (str: string) => str.replace(/([A-Z])/g, '_$1').toLowerCase();
    if (model) {
      for (const key of Object.keys(model)) {
        if (!!model[key] && model[key] instanceof Array) {
          //console.log("analizando array...", model[key]);
          apiModel[camelToSnake(key)] = model[key].map((value: any) => this.modelToSnakeCase(value));
        } else if (!!model[key] && typeof model[key] === 'object' && !(model[key] instanceof Date)) {
          //console.log("analizando objeto u otro valor", model[key]);
          apiModel[camelToSnake(key)] = this.modelToSnakeCase(model[key]);
        } else {
          //console.log("convirtiendo else ...", model[key]);
          apiModel[camelToSnake(key)] = model[key];
        }
      }
    }
    return apiModel;
  }

  /**
   * Translate given object using snake_case syntax from Rails backend and create new object of given type <T> implementing camelCase syntax
   * @param type type of class to instantiate (must implement a 'new' method)
   * @param apiModel model in snake_case to translate => camelCase
   */
  modelToCamelCase<T>(type: new (data: any) => T, apiModel: any): T | null {
    if (apiModel) {
      return new type(this.objectToCamelCase(apiModel));
    } else {
      return null;
    }
  }

  objectToCamelCase(snakeCaseModel: any): any {
    const modelData: any = {};
    if (!snakeCaseModel) {
      return;
    }

    for (const key of Object.keys(snakeCaseModel)) {
      if (snakeCaseModel[key] === null && snakeCaseModel[key] === undefined) {
        return;
      }

      if (Array.isArray(snakeCaseModel[key])) {
        const array = [];
        for (const item of snakeCaseModel[key]) {
          switch (typeof item) {
            case 'string':
              array.push(camel(item));
              break;
            case 'number':
              array.push(item);
              break;
            default:
              array.push(this.objectToCamelCase(item));
          }
        }
        modelData[camel(key)] = array;
      } else {
        if (snakeCaseModel[key] === null) {
          modelData[camel(key)] = null;
        } else {
          modelData[camel(key)] =
            typeof snakeCaseModel[key] === 'object' ? this.objectToCamelCase(snakeCaseModel[key]) : snakeCaseModel[key];
        }
      }
    }

    //console.log("modelo convert", modelData);

    return modelData;
  }
}
